import { MapColorTheme, MapColorSlotDefinition } from "@app/shared/map-appearance/interfaces";

export const CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX = "contractEntity";
export const CONTRACT_ENTITY_1_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}1`;
export const CONTRACT_ENTITY_2_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}2`;
export const CONTRACT_ENTITY_3_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}3`;
export const CONTRACT_ENTITY_4_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}4`;
export const CONTRACT_ENTITY_5_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}5`;
export const CONTRACT_ENTITY_REST_COLOR_SLOT_KEY = `${CONTRACT_ENTITY_COLOR_SLOT_KEY_PREFIX}Rest`;

export const CONTRACT_ENTITY_COLOR_SLOT_DEFINITIONS: MapColorSlotDefinition[] = [
  { key: CONTRACT_ENTITY_1_COLOR_SLOT_KEY, label: "1st Largest Servicing Contract Entity" },
  { key: CONTRACT_ENTITY_2_COLOR_SLOT_KEY, label: "2nd Largest Servicing Contract Entity" },
  { key: CONTRACT_ENTITY_3_COLOR_SLOT_KEY, label: "3rd Largest Servicing Contract Entity" },
  { key: CONTRACT_ENTITY_4_COLOR_SLOT_KEY, label: "4th Largest Servicing Contract Entity" },
  { key: CONTRACT_ENTITY_5_COLOR_SLOT_KEY, label: "5th Largest Servicing Contract Entity" },
  { key: CONTRACT_ENTITY_REST_COLOR_SLOT_KEY, label: "Rest of Servicing Contract Entities" },
];

export const CONTRACT_ENTITY_COLOR_THEME_DEFAULT: MapColorTheme = {
  colors: {
    contractEntity1: "#00A6D6",
    contractEntity2: "#42BA82",
    contractEntity3: "#FCB415",
    contractEntity4: "#F15B40",
    contractEntity5: "#1D65AB",
    contractEntityRest: "#808485",
  },
  name: "Default",
  uuid: "contract-entity-default",
};

export const CONTRACT_ENTITY_COLOR_THEME_PRESETS: MapColorTheme[] = [
  CONTRACT_ENTITY_COLOR_THEME_DEFAULT,
];
